import '../../js/vendor/magic360';
import '../../js/vendor/magicscroll';
import '../../js/vendor/magiczoomplus';
import '../app';
const magic360Container = document.getElementById('magic-360-container');
const magicScrollOptions = { items: 3, step: 1 };
const magicScrollThumbnails = document.getElementsByClassName('part__magic-scroll-images__thumbnail');
const magicZoomPlusContainer = document.getElementById('magic-zoom-plus-container');
const videosContainer = document.getElementById('video-container');
/**
 * Appliquer les bonnes options à MagicScroll en fonction de la largeur de la fenêtre.
 */
const applyCorrectMagicScrollOptions = () => {
    if (window.innerWidth < 1024) {
        magicScrollOptions.orientation = 'horizontal';
    }
    else {
        magicScrollOptions.orientation = 'vertical';
    }
    MagicScroll.updateOptions('magic-scroll-images', magicScrollOptions);
    // updatesOptions crée un chargement infini 🤔. Il faut le retirer.
    const circles = document.getElementsByClassName('mcs-loader-circles');
    if (circles.length) {
        circles[0].parentElement?.removeChild(circles[0]);
    }
};
/**
 * Afficher le bon conteneur (Magic 360 | Magic Zoom Plus | Vidéo) en fonction de l'imagette sélectionnée.
 *
 * @param {HTMLAnchorElement} thumbnail Une imagette.
 */
const toggleAppropriateMagic = (thumbnail) => {
    [magic360Container, magicZoomPlusContainer, videosContainer].forEach(function (container) {
        if (container instanceof HTMLDivElement) {
            const hiddenClass = `${container.classList.item(0)}--hidden`;
            if (container.id == `${thumbnail.dataset.zoomId}-container`) {
                if (container.id == 'video-container') {
                    const iFrame = container.getElementsByTagName('iframe')[0];
                    const src = thumbnail.dataset.src;
                    iFrame.src = `https://youtube.com/embed/${src}`;
                }
                container.classList.remove(hiddenClass);
            }
            else {
                container.classList.add(hiddenClass);
            }
        }
    });
};
window.MagicScrollOptions = {
    onReady: (scrollerId) => {
        if (scrollerId == 'magic-scroll-images') {
            applyCorrectMagicScrollOptions();
        }
    }
};
window.addEventListener('resize', () => {
    applyCorrectMagicScrollOptions();
});
Array.from(magicScrollThumbnails).forEach((thumbnail) => {
    if (thumbnail instanceof HTMLAnchorElement) {
        thumbnail.addEventListener('click', () => { toggleAppropriateMagic(thumbnail); });
        thumbnail.addEventListener('touchstart', () => { toggleAppropriateMagic(thumbnail); });
    }
});
